const EDIT_TABLE_HEADER = [
  {
    title: 'change',
    width: '5%',
  },
  {
    title: 'code',
    width: '8%',
  },
  {
    title: 'name',
    width: '10%',
  },
  {
    title: 'usage_amount',
    width: '8%',
  },
  {
    title: 'sort_key',
    width: '5%',
  },
  {
    title: 'display_group',
    width: '5%',
  },
  {
    title: 'apply_start_date',
    width: '10%',
  },
  {
    title: 'apply_end_date',
    width: '10%',
  },
  {
    title: 'remark1',
  },
  {
    title: 'remark2',
  },
  {
    title: 'delete',
    width: '5%',
  },
];

export { EDIT_TABLE_HEADER };
